import React from 'react'
import WriteOffActsFilterQuery from './fields/WriteOffActsFilterQuery'
import WriteOffActsFilterStatus from './fields/WriteOffActsFilterStatus'
import WriteOffActsFilterDepartment from './fields/WriteOffActsFilterDepartment'
import WriteOffActsFilterAgreeDirector from './fields/WriteOffActsFilterAgreeDirector'
import WriteOffActsFilterAgreeAccountant from './fields/WriteOffActsFilterAgreeAccountant'

const WriteOffActFilters = () => {
  return (
    <div className='myBlock__filtersOptions'>
		<WriteOffActsFilterQuery />
		<WriteOffActsFilterStatus />
        <WriteOffActsFilterDepartment />
        <WriteOffActsFilterAgreeDirector />
        <WriteOffActsFilterAgreeAccountant />
    </div>
  )
}

export default WriteOffActFilters